// extracted by mini-css-extract-plugin
export default {"component":"apFNF","link":"VOFbR","button":"wTdUV"};